<template lang="pug">
  .cancel-page
    SectionBlock(no-padding=true)
      transition(name="fade")
        .cancel-wrap
          .back-row
            BackButton(:url="backUrl")

          SectionTitle(text="Cancel Subscription").text-center

          ColorCrewContact
            span(v-html="customMsg")

          CancelSubBtn
  
</template>

<script>
  import { mapState } from 'vuex';
  import SectionTitle from "../../../SectionTitle";
  import SectionBlock from "../../SectionBlock";
  import BackButton from "../../BackButton";
  import ColorCrewContact from "./ColorCrewContact";
  import CancelSubBtn from "./CancelSubBtn";
  import zendeskTag from "../../../../mixins/zendeskTag";

  export default {
    name: "EditAutoDeliveryCancel",
    components: {
      CancelSubBtn,
      ColorCrewContact,
      BackButton,
      SectionBlock,
      SectionTitle
    },

    mixins: [zendeskTag],

    computed: {
      ...mapState('subscriptions', [
        'cancelData'
      ]),

      backUrl() {
        return `/dashboard/purchases/edit-auto-delivery/${this.$route.params.subId}/cancel-reasons`
      },

      customMsg() {
        let defaultText = "We are sorry it didn't work. Reach out to our licensed colorists if you have any questions.";
        return this.cancelData.reason.customMsg || defaultText;
      }
    },

    mounted() {
      if (!this.cancelData.reason.id) {
        this.$router.push({name: 'cancelReasons'});
      }

      if (this.cancelData.reason.tag) {
        this.zClick(this.cancelData.reason.tag);
      }
    }
    
  }
</script>

<style scoped lang="stylus">
  .cancel-page
    .section-title
      padding-bottom 2em

    .back-row
      margin-top 1.5em
      margin-left 1em

    .cancel-sub-btn
      padding 2em 0
</style>
